export default __webpack_public_path__ + "static/media/default_icon.a032dcf8.svg";